/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_ThemeInputs */

const en_directory_submit_badge_theme = /** @type {(inputs: Directory_Submit_Badge_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badge theme`)
};

const zh_directory_submit_badge_theme = /** @type {(inputs: Directory_Submit_Badge_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`徽章主题`)
};

/**
* | output |
* | --- |
* | "Badge theme" |
*
* @param {Directory_Submit_Badge_ThemeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_theme = /** @type {((inputs?: Directory_Submit_Badge_ThemeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_ThemeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_theme(inputs)
	return zh_directory_submit_badge_theme(inputs)
});
export { directory_submit_badge_theme as "directory.submit.badge_theme" }